module.exports = __webpack_public_path__ + "media/images/lb/140-404343b02bf7738bd037dd9b85fbec3f.svg";